import DownloadDocumentRequestModelBase from '../_generated/modelBases/download-document-request-model-base';

export default class DownloadDocumentRequestModel extends DownloadDocumentRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
